import clsx from 'clsx';

import { Sticker, StickerProps } from '@fagmobler/ui';

import type { FagmoblerAlgoliaProduct } from '@fagmobler/types';

export type TagsProps = {
  product?: FagmoblerAlgoliaProduct;
};

const ALLOWED_TAGS = [
  'KUPP!',
  'nyhet',
  'Medlemstilbud',
  'medlemstilbud',
  'BLACK WEEK',
  'outlet',
];

const getVariant = (tag: string): StickerProps['variant'] => {
  if (tag === 'KUPP!') return 'primaryDark';
  if (tag === 'nyhet') return 'secondaryDark';
  if (tag === 'BLACK WEEK') return 'neutralDark';
  if (tag === 'outlet') return 'neutralDark';
  return 'neutralDark';
};

export function Tags({ product }: TagsProps) {
  if (!product) return null;

  const tags: string[] = product.tags || [];

  return (
    <>
      {tags.length > 0 && (
        <div className={clsx('flex', 'mb-1', 'print:hidden')}>
          {tags
            ?.filter((tag) => ALLOWED_TAGS.includes(tag))
            .map((tag) => (
              <Sticker key={tag} variant={getVariant(tag)}>
                {tag === 'nyhet' ? 'Nyhet' : tag}
              </Sticker>
            ))}
        </div>
      )}
    </>
  );
}

export default Tags;
